import { Box, Spacer, TextInputNew, TextNew } from '@jfs/ui-new'
import { countDecimals } from '../../../util/util'
interface propTypes {
  multiline?: boolean
  extraDescription?: string
  textLabel?: string
  placeholder?: string
  fieldName: string
  setFieldValue: (fieldName: string, val: string | number) => void
  maxLength: number
  value?: string
  minWidth?: number
  testID?: string
}

export const leftComponent = () => {
  return (
    <TextNew type="body14" color="DARK_GREY">
      {'₹'}
    </TextNew>
  )
}

export const leftHeaderTextbox = (props: propTypes) => {
  const isMultiline = props?.multiline
  const extraDescription = props?.extraDescription
  const textLabel = props?.textLabel
  const placeholder = props?.placeholder
  const fieldName = props?.fieldName
  const setFieldValue = props?.setFieldValue
  const showRuppeeSymbol = fieldName === 'amountField'
  const minWidth = props?.minWidth

  return (
    <Box pl={'6%'} mt={5}>
      <Box flexDirection="row">
        <Box justifyContent="center" minWidth={150}>
          <TextNew type="body12" color="BLACK_21" fontWeight="bold">
            {textLabel}
          </TextNew>
        </Box>
        <Spacer direction="horizontal" size={40} />
        <Box w="20%" minWidth={minWidth ?? 200}>
          <TextInputNew
            testID={fieldName}
            weight="normal"
            onFocusBottomLineColor="TRANSPARENT"
            multiline={isMultiline}
            fontSize={12}
            leftComponent={showRuppeeSymbol && leftComponent()}
            paddingVertical={8}
            paddingHorizontal={12}
            borderRadius={5}
            placeholderTextColor="CLOUDY_GREY"
            borderColor="GREY_MATTE"
            minHeight={isMultiline ? 60 : undefined}
            bottomLineColor="TRANSPARENT"
            onChangeText={(text) => {
              if (showRuppeeSymbol) {
                const numberOfDecimals = countDecimals(text)
                if (numberOfDecimals < 3) {
                  setFieldValue(fieldName, text)
                }
              } else {
                setFieldValue(fieldName, text)
              }
            }}
            placeholder={placeholder}
            {...props}
          />
        </Box>
      </Box>
      {extraDescription && (
        <Box pt={1} paddingLeft={190}>
          <TextNew type="body12" fontSize={11} color="LIGHT_BLACK">
            {extraDescription}
          </TextNew>
        </Box>
      )}
    </Box>
  )
}

export const BackgroundSeparator = () => {
  return <Box w={'100%'} h={1} bg={'SEPERATOR'} />
}
